import { updateReservation, UpdateReservationProps } from './updateReservation'
import { deleteAllReservation } from './deleteReservation'
import { getReservations } from './getReservations'
import { patientRestrictions, RestrictionsStatus } from './patientRestrictions'
import { availabilities, Availabilities, WeekDays, Availability } from './availabilities'
import { professionalRestrictions, ProfessionalRestrictions } from './professionalRestrictions'
import { createReservation, Reservation } from './createReservation'
import { getSlotRestriction } from './getSlotRestriction'
import { getNextReservationEvents } from './getNextReservationEvents'
import { getPatientReservations } from './getPatientReservations'

export default {
  updateReservation,
  deleteAllReservation,
  getReservations,
  patientRestrictions,
  availabilities,
  professionalRestrictions,
  createReservation,
  getSlotRestriction,
  getNextReservationEvents,
  getPatientReservations
}

export type {
  UpdateReservationProps,
  Availabilities,
  WeekDays,
  Availability,
  ProfessionalRestrictions,
  Reservation,
}

export { RestrictionsStatus }